import React from 'react'
import posed from 'react-pose'
import styled from 'styled-components'

import PostThumbnail from 'components/PostThumbnail'

import { StyledList } from './styles'
import Pagination from './Pagination'

function PaginatedPostsList({ list, fullWidth = false, pagination, path, isOpen }) {
   return (
      <StyledList fullWidth={fullWidth}>
         <PosedList pose={isOpen ? 'open' : 'exit'}>
            {list.map((post) => (
               <StyledPostWrapper className="no-js-visibility" key={post.id}>
                  <PostThumbnail {...post} fullWidth={fullWidth} />
               </StyledPostWrapper>
            ))}
         </PosedList>
         {pagination && <Pagination data={pagination} path={path} />}
      </StyledList>
   )
}

const PosedList = posed.div({
   open: {
      staggerChildren: 200,
   },
   initialPose: 'exit',
})

const Post = posed.div({
   open: { opacity: 1, y: 0 },
   enter: { opacity: 1, y: 0 },
   exit: { opacity: 0, y: 8 },
})

const StyledPostWrapper = styled(Post)``

export default PaginatedPostsList
